import React, { useEffect } from 'react';
import { DashboardLayout } from '../components/UI/Layout/DashboardLayout';
import OrganizationsComponent from 'components/Organizations/OrganizationsComponent';

export const Organizations: React.FC = () => {
    useEffect(() => {
        document.title = 'Organizations';
    }, []);

    return (
        <DashboardLayout>
            <OrganizationsComponent />
        </DashboardLayout>
    );
};

export default Organizations;
